module.exports = __webpack_public_path__ + "static/img/icon_staking_failed.81c3009a.png";